export const segmentos = [
    { id: 1, nome: 'SOMENTE VAREJO' },
    { id: 2, nome: 'SOMENTE LOJA FISICA' },
    { id: 3, nome: 'VAREJO & FISICA' },
]